import axios from 'axios';

const http = axios.create({
  baseURL: import.meta.env.VITE_APP_API || 'http://localhost:5000/',
  withCredentials: true,
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

function unwrap(response) {
  const body = response?.data;
  const status = body?.status ?? body?.Status;
  if (status === undefined) return body;
  if (status === 0) return body.data ?? body.Data;

  const error = new Error(body?.message || body?.Message || 'Request failed');
  error.status = status;
  error.data = body?.data ?? body?.Data;
  throw error;
}

async function request(action) {
  try {
    return unwrap(await action());
  } catch (error) {
    if (error?.status !== undefined && error?.response === undefined) throw error;
    const body = error?.response?.data;
    const normalized = new Error(body?.message || body?.Message || error?.message || 'Request failed');
    normalized.httpStatus = error?.response?.status;
    normalized.status = body?.status ?? body?.Status;
    normalized.data = body?.data ?? body?.Data;
    throw normalized;
  }
}

const ROOT = 'api/v1/TaxFeedbackSettings';

export const taxFeedbackSettingsApi = {
  getSettings() {
    return request(() => http.get(ROOT));
  },
  saveSettings(items) {
    return request(() => http.post(`${ROOT}/save`, { items }));
  },
};

export default taxFeedbackSettingsApi;
